import axios from 'axios';
import qs from "qs";
import {config} from '../config';

//Todo: Remove following hardcodings with configs stored in redux

//Todo: To add some common headers being part of each request.
const defaultHeaders = {
};
const instance = axios.create();

instance.interceptors.request.use(configuration => {
    const API_KEY_HEADER = config('NP_API_KEY_HEADER_NAME') || "x-api-key";
    const API_KEY = config('NP_API_KEY_CLIENT_JS') || "NSjMi38PBJ6s1rvNMA9FKO6FRn2iDd95bEDoaij8";
    if (configuration.url?.includes('api.pens.com')) {
        configuration.headers![API_KEY_HEADER] = API_KEY;
    }

    //Todo: Need to add other conditional headers for Ctools and other apis.
    return configuration;
});

instance.interceptors.response.use(config => {
    //Todo: Need to put generic Sentry call handling here for api call failures
    return config;
});

//Todo: add try catch error handling and handle generic failures in catch for both get and post
export const get = async (url: string, params?: object, headers?: object) =>{
    return instance.get(`${url}?${qs.stringify(params)}`,
        { ...defaultHeaders, ...headers }
    );
}

export const post = async (url: string, data?: any, headers?: object) =>
    instance.post(url,
        data,
        { ...defaultHeaders, ...headers });